/**
 * Enum representing different application zones.
 *
 * @usageNotes
 * The `PlatformZones` enum defines constants for client and admin zones respectively:
 * ADMIN_ZONE and CLIENT_ZONE.
 */
export enum PlatformZones {
    ADMIN_ZONE,
    CLIENT_ZONE,
}
